import fetch from "@/utils/request";


export default {
  // 提交开户数据
  supplementSaveApi(data?: object): any {
    return fetch({
      url: "/php/api/v2/account/supplement/save",
      method: "post",
      data,
      customLoading: (data && (data as any).showLoading) || false
    });
  },
  // 获取开户数据
  accountSituationV2(params: any): any {
    return fetch({
      url: "/php/api/v2/account/situation",
      method: "get",
      params,
      customLoading: params?.showLoading || false
    });
  },
  // readID初始化
  zolozInitializeApi(data: any){
    return fetch({
      url: '/php/api/zoloz/initialize',
      method: "post",
      data,
      hideFailMessage: true
    })
  },

  zolozInitializeOcrApi(data: any){
    return fetch({
      url: '/php/api/zoloz/idrecognition/initialize',
      method: "post",
      data
    })
  },
  // 交易品种
  accountServerNewLists(): any {
    return fetch({
      url: "/php/api/v2/account/server/newLists",
      method: "get"
    });
  },
  // 人脸识别 视频上传
  accountUploadFaceVideo(data:any){
    return fetch({
      url: '/php/api/account/upload',
      method: "post",
      headers: {
        post: {
          "Content-Type": "multipart/form-data"
        }
      },
      data
    })
  },
  // 获取认证结果
  faceCheckApi(params: any){
    return fetch({
      url: "/php/api/faceCheck",
      method: "get",
      params
    });
  },
  // 邮箱校验
  accountSendEmail(data: any){
    return fetch({
      url: '/php/api/v2/account/send/email',
      method: "post",
      data
    })
  },
  supplementClear(){
    return fetch({
      url: "/php/api/v2/account/supplement/clear",
      method: "get"
    });
  },
  // 提交开户申请
  openAccountSubmission(params: any){
    return fetch({
      url: '/php/api/v2/account/accountFirstSave',
      method: "get",
      params
    })
  },
  // zoloz 获取结果
  getZolozCheckResultApi(params: any){
    return fetch({
      url: '/php/api/zoloz/checkresult',
      method: "get",
      params
    })
  },
  // 获取风险评估结果
  getAccountRiskResultApi(data: any){
    return fetch({
      url: '/php/api/v2/account/risk/result',
      method: "post",
      data
    })
  },
  // 获取编号
  getAccountAcceptanceSnApi(params: any){
    return fetch({
      url: '/php/api/v2/account/acceptance_sn',
      method: "get",
      params
    })
  },
  // 二次开户提交
  saveAccountAccountSecondSaveApi(data: any){
    return fetch({
      url: '/php/api/v2/account/accountSecondSave',
      method: "post",
      data
    })
  },
  // 获取被拒账户资料信息
  getAuditMaterials(params: any){
    return fetch({
      url: '/php/api/v2/account/supplement/info',
      method: "get",
      params
    })
  },
  submitOrgAccountType(data?: object): any {
    return fetch({
      url: "/php/api/account/save/server",
      method: "post",
      data
    });
  },
  saveAccountOpeningInfo(data?: object): any {
    return fetch({
      url: "/php/api/account/company/save",
      method: "post",
      data
    });
  },
  


};


